import React, { useContext } from 'react'
import AuthContext from './AuthContext'
import { Button } from '@mui/material'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { defaultSettings } from './constants'
import MsLogo from './img/ms_logo.svg'
const axios = require('axios').default

export default (props) => {
  const { signIn } = useContext(AuthContext)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const redirectTo = window.location.href.split('?')[0]

  // Handle OAuth callback for both login and calendar connection
  const processedRef = React.useRef(false)

  React.useEffect(() => {
    const code = searchParams.get('code')
    const state = searchParams.get('state')

    if (code && state && !processedRef.current) {
      processedRef.current = true
      props.setLoading(true)

      // Parse the state to determine if this is login or calendar connection
      try {
        const stateData = JSON.parse(atob(state))

        if (stateData.mode === 'login') {
          // Login mode - authenticate user with Microsoft
          axios.post('https://hlpscbffug.execute-api.us-west-2.amazonaws.com/prod/microsoft/login', {
            code: code,
            state: state,
            redirectTo: redirectTo,
            settings: defaultSettings
          })
          .then(res => {
            res.data.user.username = res.data.username
            signIn(res.data.token, res.data.user)
            props.setUser(res)
            props.setLoading(false)
            // Clear the URL params to prevent re-processing
            navigate('/dashboard/events', { replace: true })
          })
          .catch(err => {
            console.log(err)
            props.setLoading(false)
            processedRef.current = false
          })
        } else if (props.token) {
          // Connect calendar mode - existing functionality
          axios.post('https://hlpscbffug.execute-api.us-west-2.amazonaws.com/prod/microsoft/connect', {
            token: props.token,
            code: code,
            redirectTo: redirectTo
          })
          .then(res => {
            props.setUser(res)
            props.setLoading(false)
            navigate('/dashboard/calendars', { replace: true })
          })
          .catch(err => {
            console.log(err)
            props.setLoading(false)
            processedRef.current = false
          })
        }
      } catch (e) {
        // Fallback for old flow without state parsing
        if (props.token) {
          axios.post('https://hlpscbffug.execute-api.us-west-2.amazonaws.com/prod/microsoft/connect', {
            token: props.token,
            code: code,
            redirectTo: redirectTo
          })
          .then(res => {
            navigate('/dashboard/calendars', { replace: true })
          })
          .catch(err => {
            processedRef.current = false
          })
        } else {
          processedRef.current = false
        }
      }
    }
  }, [searchParams])

  const openMs = () => {
    props.setLoading(true)

    // Pass mode in the request so backend can set it in state
    const requestData = {
      redirectTo: redirectTo,
      mode: props.login ? 'login' : 'connect'
    }

    axios.post('https://hlpscbffug.execute-api.us-west-2.amazonaws.com/prod/microsoft/auth', requestData)
    .then(res => {
      window.location.assign(res.data.authCodeUrl)
    })
    .catch(err => {
      console.log(err)
      props.setLoading(false)
    })
  }

  return (
    <div style={{marginTop: 10}}>
      <Button style={{backgroundColor: '#2F2F2F', height: 55, width: '100%', display: 'block'}} onClick={openMs}>
        <img style={{margin: 6, textAlign: 'center', display: 'block', float: 'left', whiteSpace: 'nowrap'}} src={MsLogo} />
        <p style={{color: '#FFFFFF', fontFamily: 'Segoe UI Regular', margin: 4, fontSize: '15px', fontWeigth: 600, textTransform: 'none'}}>
        Sign in with Microsoft
      </p>
      </Button>
    </div>
  )
}